import React from 'react'
import {Consumer} from '../../context'
import Lesson from './lesson'
import  './lessons.styl'

export default function Lessons () {
  return (<Consumer>{ context => {
    const {lessons} = context
    return (
      <ul className="lessons">
        {lessons && lessons.map(lesson => (<Lesson key={lesson.id} {...lesson} />))}
      </ul>
    )
  }}</Consumer>)
}
